import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import * as actions from '../../storeDispatcher/actions'
import Header from "../Header";
import DescriptionBlock from "../DescriptionBlock";
import TrackList from "../ContentBlock";
import Footer from "../Footer";
import Settings from "../Settings/Settings";
import ConnectedObjectList from "../ConnectedObjectList";
import StoreManager from "../../managers/StoreManager";
import InfoManager from "../../managers/InfoManager";
import SplashScreen from "../SplashScreen";
import CookieMessage from "../CookieMessage/CookieMessage";
import CookieManager from "../../managers/CookieManager";


class App extends React.Component {

    static instance;

    setLanguage = (value) => {
        this.props.languageSwitch(value);
        CookieManager.language = value;
    };

    async downloadObject() {
        // https://*.explainitapp.com/play/?<objectId>&<fromObjectId>
        const getParametersLine = window.location.href.split('?')[1];
        const getParameters = (getParametersLine || "").split('&');

        const oldObjectId = getParameters[0];
        const fromObjectId = getParameters[1];


        const objectId = oldObjectId || this.props.match.params.objectId || this.props.objectId;

        await StoreManager.downloadObject(objectId, fromObjectId);

        const cookieLanguage = CookieManager.language;
        if (cookieLanguage) {
            this.props.languageSwitch(cookieLanguage);
        }

    }

    async componentDidMount() {
        console.log('App did mount');
        App.instance = this;
        await this.downloadObject();
        console.log(InfoManager.systemLanguageList.join('; '));
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        console.log('did update');
        //if (this.props.object && this.props.object.objectId !== this.props.objectId) await this.downloadObject();
    }

    render() {
        const {object, selectedLanguage} = this.props;
        const languageList = object ? object.languageList : [];


        if (!object) return (
            <div className='container'>
                <SplashScreen />
            </div>
        );


        return (
            <div className='container'>
                <Header selectedLanguage={selectedLanguage}/>

                <DescriptionBlock/>
                <TrackList/>

                <Footer />

                <CookieMessage />
                <Settings languageList={languageList} setLanguage={this.setLanguage}/>
                <ConnectedObjectList object={object}/>
            </div>
        );
    }

}


const mapStateToProps = ({objectId, object, selectedLanguage}) => {
    return {objectId, object, selectedLanguage}
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(actions, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(App);